import { render, staticRenderFns } from "./FundAccountEdit.vue?vue&type=template&id=3d10147e&scoped=true"
import script from "./FundAccountEdit.vue?vue&type=script&lang=js"
export * from "./FundAccountEdit.vue?vue&type=script&lang=js"
import style0 from "./FundAccountEdit.vue?vue&type=style&index=0&id=3d10147e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d10147e",
  null
  
)

export default component.exports